import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import LoadingPanel from "../components/sys-toolbox/LoadingPanel";

import JobApplicationListPage from "../pages/JobApplication/JobApplicationList";
import JobApplicationPage from "../pages/JobApplication/JobApplicationPage";
import { NoMatch } from "../utils/common";

const App = () => {
  return (
    <Layout>
      <Suspense fallback={LoadingPanel}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

/**
 * @type {import("react-router-dom").RouteObject[]}
 */
export const protectedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "list",
        element: <JobApplicationListPage />,
      },
      {
        path: "list/:candidateId",
        element: <JobApplicationPage />,
      },
      { path: "404", element: <NoMatch /> },
      { path: "/", element: <Navigate to="/list" /> },
    ],
  },
];
